import React from 'react';
import './sidebar.css';

const settingsOptions = [
  'System Preferences',
  'Email Settings',
  'Personal Settings',
  'Payment Methods',
  'WiFi Preferences',
  'Device Settings'
];

function Sidebar({ selected, onSelect }) {
  return (
    <div className="sidebar-settings">
      <h2 className="sidebar-title">Settings</h2>
      <ul className="sidebar-list">
        {settingsOptions.map(option => (
          <li
            key={option}
            className={`sidebar-item ${selected === option ? 'active' : ''}`}
            onClick={() => onSelect(option)}
          >
            {option}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
